import React from 'react';
import classnames from 'classnames';
import {
  LISTING_CATEGORIES,
  STYLE_BY_CATEGORY,
  ListingCategory,
} from '../../../JSDC/utils/listingCategoryIcon';
import { STRUCTURE_LAYERS } from '../Layer/StructureLayers';
import './LegendDialogContent.scss';

type LegendEntry = {
  name: string;
  icon: string;
  color: string;
};

const EXTRA_LEGENDS: Array<LegendEntry> = STRUCTURE_LAYERS.map((l) => ({
  name: l.name,
  icon: l.icon,
  color: l.color,
}));

export interface ILegendDialogContentProps {
  activeLegends?: Array<ListingCategory>;
}

const LegendDialogContent: React.FC<ILegendDialogContentProps> = ({
  activeLegends,
}: ILegendDialogContentProps) => {
  const isActive = (category: ListingCategory) =>
    !activeLegends || activeLegends.includes(category);

  const renderItem = (entry: LegendEntry, inactive = false) => (
    <div
      key={entry.name}
      className={classnames('dui-LegendDialogContent-Item', {
        'is-inactive': inactive,
      })}
    >
      <div
        className="dui-LegendDialogContent-Item-Icon"
        style={{ background: entry.color }}
      >
        <i className={`las ${entry.icon}`} />
      </div>
      <div className="dui-LegendDialogContent-Item-Name">{entry.name}</div>
    </div>
  );

  return (
    <div className="dui-LegendDialogContent">
      {LISTING_CATEGORIES.map((category) =>
        renderItem({ name: category, ...STYLE_BY_CATEGORY[category] }, !isActive(category)),
      )}
      {EXTRA_LEGENDS.map((entry) => renderItem(entry))}
    </div>
  );
};
LegendDialogContent.displayName = 'LegendDialogContent';
export default LegendDialogContent;
